<template>
  <div class="minusplusnumber">
      <div class="mpbtn minus" v-bind:class="{'disabled': disabled}" v-on:click="mpminus()">
          -
      </div>
      <div id="field_container">
          <input type="number" v-bind:class="{'disabled': disabled}" v-model="newValue" :disabled="disabled" @change="valueChanged()"/>
      </div>
      <div class="mpbtn plus" v-bind:class="{'disabled': disabled}" v-on:click="mpplus()">
          +
      </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: 0,
      type: Number
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: undefined,
      type: Number
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },

  data () {
    return {
      newValue: 0
    }
  },

  methods: {
    getNotificationClass (notification) {
      return `alert alert-${notification.type}`
    },
    mpplus: function () {
      if (this.max === undefined || (this.newValue < this.max)) {
        this.newValue = this.newValue + 1
        this.$emit('input', this.newValue)
      }
    },
    mpminus: function () {
      if ((this.newValue) > this.min) {
        this.newValue = this.newValue - 1
        this.$emit('input', this.newValue)
      }
    },
    valueChanged: function () {
      this.newValue = this.newValue > this.max ? this.max : this.newValue;
      this.$emit('input', this.newValue)
    }
  },
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        this.newValue = newVal
      }
    }
  },
  created: function () {
    this.newValue = this.value
  }
}
</script>
<style lang="scss" scoped>
  .minusplusnumber {
      border:1px solid silver;
      border-radius:5px;
      background-color: #FFF;
      margin:0 5px 0 5px;
      display:inline-block;
      user-select: none;
  }
  .minusplusnumber div {
      display:inline-block;
  }
  .minusplusnumber #field_container input {
      width:50px;
      text-align:center;
      font-size:15px;
      padding:3px;
      border:none;
      margin-left: 0 !important;
  }
  /* Chrome, Safari, Edge, Opera */
  .minusplusnumber #field_container input::-webkit-outer-spin-button,
  .minusplusnumber #field_container input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.minusplusnumber #field_container input[type=number] {
  -moz-appearance: textfield;
}
  .minusplusnumber .mpbtn {
    padding:3px 10px 3px 10px;
    cursor:pointer;
    border-radius:5px;
  }
  .minusplusnumber .mpbtn:hover {
      background-color:#DDD;
  }
  .minusplusnumber .mpbtn:active {
      background-color:#c5c5c5;
  }
  .disabled {
    pointer-events: none;
    opacity: 0.4;
  }
</style>
